import { createAction } from '@reduxjs/toolkit';

import { Comment } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import { CreateCommentRequest, DeleteCommentRequest, ViewCommentsRequest } from './comment.types';

export const requestCreateComment =
  createAction<SagaPayload<CreateCommentRequest, string | undefined>['payload']>('request/createComment');

export const requestViewComments =
  createAction<SagaPayload<ViewCommentsRequest, Comment[]>['payload']>('request/viewComments');

export const requestDeleteComment = createAction<SagaPayload<DeleteCommentRequest>['payload']>('request/deleteComment');
